<base-checkbox
  [isChecked]="permission.isSelected"
  [label]="permissionCheckboxLabel"
  (getChange)="onPermissionSelect($event)"
></base-checkbox>
<ng-template #permissionCheckboxLabel>
  <base-permission-checkbox-template [permission]="permission"></base-permission-checkbox-template>
</ng-template>
